const ROOT = document.documentElement;

const CLASS = "incluway-dyslexic-font";
const LINK_ID = "incluway-dyslexic-font-link";
const STYLE_ID = "incluway-dyslexic-font-style";

const FONT_CSS_URL = "https://fonts.cdnfonts.com/css/open-dyslexic";

function ensureLink() {
  if (document.getElementById(LINK_ID)) return;

  const link = document.createElement("link");
  link.id = LINK_ID;
  link.rel = "stylesheet";
  link.href = FONT_CSS_URL;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

function ensureStyle() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;

  style.textContent = `
    html.${CLASS} :not(.incluway-excluded):not(.incluway-excluded *)
      :not(#widget-container):not(#widget-container *)
      :not(#reactWidgetIframe):not(#reactWidgetIframe *) {
      font-family: "Open-Dyslexic", "OpenDyslexic", Arial, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif !important;
    }
  `.trim();

  document.head.appendChild(style);
}

export function enableDyslexicFont() {
  ensureLink();
  ensureStyle();
  ROOT.classList.add(CLASS);
}

export function disableDyslexicFont() {
  ROOT.classList.remove(CLASS);
}
